module.exports = __webpack_public_path__ + "static/media/icon-forms-white.477d6d2f.svg";